"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleHeaderDesktop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _userUtils = require("../header/userUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  header: {
    height: 64
  },
  logo: {
    padding: 0
  },
  primaryText: {
    color: theme.palette.text.primary,
    width: 200
  },
  secondaryText: {
    color: theme.palette.text.secondary,
    fontSize: 14
  },
  avatar: {
    position: 'absolute',
    right: 0,
    padding: 0,
    marginLeft: 24,
    marginRight: 24
  },
  menu: {
    marginTop: 48
  },
  menuAvatar: {
    marginRight: 16
  },
  menuIcons: {
    marginRight: 24,
    marginLeft: 8
  },
  menuItemText: {
    color: theme.palette.text.primary,
    width: 200,
    fontSize: 14
  }
}));
const SimpleHeaderDesktop = _ref => {
  let {
    username,
    email,
    onClickHome,
    onExit,
    logo
  } = _ref;
  const classes = useStyles();
  const initials = (0, _userUtils.getInitials)(username);
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const open = Boolean(anchorEl);
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  function renderMenu() {
    return /*#__PURE__*/_react.default.createElement(_core.Menu, {
      className: classes.menu,
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: open,
      onClose: handleClose
    }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      style: {
        marginTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.menuAvatar
    }, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText
    }, (0, _userUtils.listUser)(username, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.secondaryText
    }, (0, _userUtils.listUser)(email, 28)))), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: onExit
    }, /*#__PURE__*/_react.default.createElement(_icons.ExitToApp, {
      style: {
        marginRight: 24,
        marginLeft: 8
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.menuItemText
    }, "Sair")));
  }
  function renderAvatar() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      className: classes.avatar,
      onClick: handleMenu
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), renderMenu());
  }
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.logo,
    onClick: onClickHome
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxHeight: 40
    },
    src: logo,
    alt: "logo"
  })), renderAvatar()));
};
exports.SimpleHeaderDesktop = SimpleHeaderDesktop;
SimpleHeaderDesktop.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string,
  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,
  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,
  /**
   * Logo que aparecerá no topo da página
   */
  logo: _propTypes.default.element.isRequired
};
SimpleHeaderDesktop.propTypes = {
  username: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  onClickHome: _propTypes.default.func.isRequired,
  onExit: _propTypes.default.func.isRequired
};
var _default = exports.default = SimpleHeaderDesktop;